import { render } from "./AlimentazionePage.vue?vue&type=template&id=4a81f282&scoped=true"
import script from "./AlimentazionePage.vue?vue&type=script&lang=js"
export * from "./AlimentazionePage.vue?vue&type=script&lang=js"

import "./AlimentazionePage.vue?vue&type=style&index=0&id=4a81f282&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a81f282"]])

export default __exports__